import { useState, useEffect } from 'react'

function useMedia(query) {
  const [matches, setMatches] = useState(window.matchMedia(query).matches)

  useEffect(() => {
    const resizeListener = () => {
      const res = window.matchMedia(query)
      setMatches(res.matches)
    }
    //console.log('adding media listener')
    window.addEventListener('resize', resizeListener)
    return () => {
      //console.log('removing media listener')
      window.removeEventListener('resize', resizeListener)
    }
  }, [])

  return { matches }
}

export default useMedia
